module.exports = __webpack_public_path__ + "img/background.37bc5698.jpg";